import { Container } from '@mui/material'
import { IndiaReadsContact } from '../constant/constant'
const ContactIndiaReads = () => {
    return (
        <div className='ourExecutiveCommittee-containter'>
            <div className="pt-5">
                <header className="chapter-heading">
                    <h2 className="text-center title-font text-light py-3 mt-1">Contact For India Reads</h2>
                </header>
            </div>
            <Container maxWidth="xl">
                <div className='row'>
                    <div className='col-md-12'>
                        <p className='mt-5 text-center'>To know more about India Reads <a href="mailto:indiareads@eltai.in" className='text-decoration-underline text-secondary-new'>indiareads@eltai.in</a></p>
                        <div className="d-flex justify-content-center align-items-center my-5 gap-5">
                            {IndiaReadsContact.map(contact => (
                                <div className="card shadow news-card-india-reads-containter" >
                                    <img
                                        src={contact?.img}
                                        className="card-img-top-news-india-reads"
                                        alt="Card"
                                    />
                                    <div className="card-body card-text-india-reads content-font">
                                        <h5 className="card-title">{contact.name}</h5>
                                        <p >
                                            <p className='mb-0'>{contact?.mobile}</p>
                                            <p className='mb-0'>{contact?.email}</p>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>


            </Container>

        </div>
    )
}

export default ContactIndiaReads
